const NOVA_SELECTOR = ".bacurr-cur-blocker";
const HEADER_SLOT_SELECTOR = "[data-nova-currency-header]";
const FOOTER_SLOT_SELECTOR = "[data-nova-currency-footer]";
const MOBILE_SLOT_SELECTOR = "[data-nova-currency-mobile]";
const CURRENCY_SYMBOLS = {
  AED: "د.إ",
  BHD: "د.ب",
  IQD: "ع.د",
  KWD: "د.ك",
  OMR: "ر.ع.",
  QAR: "ر.ق",
};

function createChevron() {
  const chevron = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  chevron.setAttribute("role", "presentation");
  chevron.setAttribute("focusable", "false");
  chevron.setAttribute("width", "10");
  chevron.setAttribute("height", "7");
  chevron.setAttribute("viewBox", "0 0 10 7");
  chevron.setAttribute("class", "icon icon-chevron-bottom nova-currency-chevron");

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", "m1 1 4 4 4-4");
  path.setAttribute("fill", "none");
  path.setAttribute("stroke", "currentColor");
  path.setAttribute("stroke-width", "2");
  chevron.append(path);

  return chevron;
}

function decorateChoice(choice, currency) {
  if (!choice) return;

  let symbol = choice.querySelector(".nova-currency-symbol");

  if (!symbol) {
    symbol = document.createElement("span");
    symbol.className = "nova-currency-symbol";
    symbol.dir = "rtl";
    choice.querySelector(".ba-chosen")?.after(symbol);
  }

  const symbolText = CURRENCY_SYMBOLS[currency] || "";
  if (symbol.textContent !== symbolText) symbol.textContent = symbolText;

  if (!choice.querySelector(".nova-currency-chevron")) {
    choice.append(createChevron());
  }
}

function initializeNovaCurrencySelectors() {
  const novaSelector = document.querySelector(NOVA_SELECTOR);
  const headerSlot = document.querySelector(HEADER_SLOT_SELECTOR);
  const footerSlot = document.querySelector(FOOTER_SLOT_SELECTOR);
  const mobileSlot = document.querySelector(MOBILE_SLOT_SELECTOR);

  if (!novaSelector || (!headerSlot && !footerSlot && !mobileSlot)) {
    return false;
  }

  if (novaSelector.dataset.customPlacementInitialized === "true") {
    return true;
  }

  const novaSelect = novaSelector.querySelector("#baCurrSelector");

  if (!novaSelect) {
    return false;
  }

  novaSelector.dataset.customPlacementInitialized = "true";

  if (headerSlot) {
    headerSlot.append(novaSelector);
    headerSlot.hidden = false;
  } else {
    novaSelector.classList.add("nova-currency-source--hidden");
  }

  decorateChoice(novaSelector.querySelector(".bacurr-choiceDesign"), novaSelect.value);

  const createProxyControl = (slot) => {
    const novaChoices = novaSelector.querySelector(".bacurr-dropdownChoices");
    const novaBlock = novaSelector.querySelector(".bacurr-cur-block");
    const proxySelector = document.createElement("div");
    proxySelector.className = novaChoices.className;
    Array.from(novaBlock.classList)
      .filter((className) => className.startsWith("baCountry-"))
      .forEach((className) => proxySelector.classList.add(className));

    const choice = novaSelector
      .querySelector(".bacurr-choiceDesign")
      .cloneNode(true);
    const select = novaSelect.cloneNode(true);
    select.removeAttribute("id");
    select.querySelectorAll("[id]").forEach((element) => {
      element.removeAttribute("id");
    });
    select.className = "nova-currency-select";
    select.setAttribute("aria-label", "Currency");
    select.value = novaSelect.value;
    proxySelector.append(choice, select);
    slot.replaceChildren(proxySelector);
    slot.hidden = false;

    return { choice, select };
  };

  const proxyControls = [footerSlot, mobileSlot]
    .filter(Boolean)
    .map(createProxyControl);

  const getNovaSelect = () =>
    novaSelector.querySelector("#baCurrSelector, select.bacurr");

  const getCurrentCurrency = (liveNovaSelect) => {
    const displayedCurrency = novaSelector
      .querySelector(".bacurr-choiceDesign .ba-chosen")
      ?.textContent.trim()
      .toUpperCase();
    const availableCurrencies = Array.from(liveNovaSelect.options).map(
      (option) => option.value
    );

    return availableCurrencies.includes(displayedCurrency)
      ? displayedCurrency
      : liveNovaSelect.value;
  };

  const syncDisplays = () => {
    const liveNovaSelect = getNovaSelect();
    if (!liveNovaSelect) return;

    const currency = getCurrentCurrency(liveNovaSelect);
    decorateChoice(novaSelector.querySelector(".bacurr-choiceDesign"), currency);

    proxyControls.forEach(({ choice, select }) => {
      select.value = currency;
      decorateChoice(choice, currency);

      const chosen = choice.querySelector(".ba-chosen");
      const flag = choice.querySelector(".baCountry");

      if (chosen && chosen.textContent !== currency) chosen.textContent = currency;

      if (flag) {
        Array.from(flag.classList)
          .filter((className) => className.startsWith("baCountry-"))
          .forEach((className) => flag.classList.remove(className));
        flag.classList.add(`baCountry-${currency}`);
      }
    });
  };

  syncDisplays();

  proxyControls.forEach(({ select }) => {
    select.addEventListener("change", () => {
      const liveNovaSelect = getNovaSelect();
      if (!liveNovaSelect) return;

      liveNovaSelect.value = select.value;

      const novaChoice = Array.from(
        novaSelector.querySelectorAll(".bacurr-dropdown-choices .currMovers")
      ).find((choice) => choice.getAttribute("rel") === select.value);

      if (novaChoice) {
        novaChoice.click();
      } else {
        liveNovaSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }

      syncDisplays();
    });
  });

  novaSelector.addEventListener("change", syncDisplays);
  novaSelector.addEventListener("click", () => requestAnimationFrame(syncDisplays));

  new MutationObserver(syncDisplays).observe(novaSelector, {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  });

  const initialSyncInterval = window.setInterval(syncDisplays, 250);
  window.setTimeout(() => window.clearInterval(initialSyncInterval), 10000);
  window.addEventListener("pageshow", syncDisplays, { once: true });

  return true;
}

if (!initializeNovaCurrencySelectors()) {
  const observer = new MutationObserver(() => {
    if (initializeNovaCurrencySelectors()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
